import React from 'react'
import { Slider } from './Slider'

interface Props {
  className?: string
  min: number
  max: number
  step: number
  value: number
  showTooltip?: boolean
  onChange: (value: number) => void
}

export const SliderWithLabels: React.FC<Props> = ({
  className = '',
  min,
  max,
  step,
  value,
  showTooltip = false,
  onChange,
}) => {
  return (
    <div className={`${className} relative`}>
      <div className="flex items-center gray700 f6">
        <div className="mr3 user-select-none">{min}</div>
        <Slider
          min={min}
          max={max}
          step={step}
          value={value}
          showTooltip={showTooltip}
          onChange={onChange}
        />
        <div className="ml3 user-select-none">{max}</div>
      </div>
    </div>
  )
}
